const VariableChip = ({
    label,
    value,
    onClick,
}) => {

    return (

        <button
            type="button"
            className="btn btn-light btn-sm"
            onClick={() => onClick?.(value)}
        >
            {label}
        </button>

    );

};

export default VariableChip;